import {
  REQUEST_ORDERS_LOADING,
  REQUEST_ORDERS_SUCCESS,
  ADD_OR_UPDATE_ORDERS,
  ADD_OR_UPDATE_ORDER_DETAILS
} from './action-constants';

const initialState = {
  count: 0,
  nextPage: null,
  prevPage: null,
  page: null,
  ordersLoading: false,
  orders: {},
  orderDetails: {}
};

export const reducerKey = 'orderHistory';

export const reducer = (state = initialState, action = { type: '', payload: {} }) => {
  switch (action.type) {
    case REQUEST_ORDERS_SUCCESS: {
      const { orders, page, nextPage, previousPage, count } = action.payload || {};
      return {
        ...state,
        orders: {
          ...state.orders,
          ...orders
        },
        nextPage,
        previousPage,
        page,
        count
      };
    }
    case REQUEST_ORDERS_LOADING: {
      return {
        ...state,
        ordersLoading: action.payload
      };
    }
    case ADD_OR_UPDATE_ORDERS: {
      const orders = action.payload || {};
      return {
        ...state,
        orders: {
          ...state.orders,
          ...orders
        }
      };
    }
    case ADD_OR_UPDATE_ORDER_DETAILS: {
      const orderDetails = {...state.orderDetails};
      const orderDetailsInstance = action.payload;
      orderDetails[orderDetailsInstance.id()] = orderDetailsInstance;

      return {
        ...state,
        orderDetails
      };
    }
    default: {
      return state;
    }
  }
};
